"use client";

import { FinancingVideoShowcase } from "@/components/blocks/financing-video-showcase";
import type { FinancingVideoEpisode } from "@/components/blocks/financing-video-showcase";

import type { VideoEpisode } from "./data";
import { EarlyStageSection } from "./section-frame";

interface EarlyStageVideoShowcaseProps {
  title: string;
  ctaLabel: string;
  ctaHref: string;
  episodes: VideoEpisode[];
  className?: string;
}

function toFinancingEpisodes(
  episodes: VideoEpisode[]
): FinancingVideoEpisode[] {
  return episodes.map((episode) => ({
    id: episode.playbackId,
    playbackId: episode.playbackId,
    title: episode.title,
    storyLabel: episode.storyLabel,
    href: episode.href,
  }));
}

export function EarlyStageVideoShowcase({
  title,
  ctaLabel,
  ctaHref,
  episodes,
  className,
}: EarlyStageVideoShowcaseProps) {
  return (
    <FinancingVideoShowcase
      title={title}
      ctaLabel={ctaLabel}
      ctaHref={ctaHref}
      episodes={toFinancingEpisodes(episodes)}
      dataTestId="video-carousel-section"
      renderShell={(content) => (
        <EarlyStageSection
          id="early-stage-video"
          dataTestId="early-stage-video-section"
          sectionClassName="flex flex-col gap-12 py-20"
          className={className}
        >
          {content}
        </EarlyStageSection>
      )}
    />
  );
}
